import React, { lazy, Suspense } from 'react';
import $ from 'jquery';
import { Router, Route, Switch, withRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import cookie from 'react-cookies';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import ReactGA from 'react-ga';
import { Provider, connect } from "react-redux";
import { legacy_createStore as createStore } from 'redux'
import reducer, { StoreUserData, StoreUser, StoreMasterData, StoreAuthToken } from "./DataStore";
import Home from "./home.js";
import ErrorBoundary from "./ErrorBoundary";
import PageVisibility from 'react-page-visibility';
import LoadingPlaceHolder from './RLoadingPlaceHolder';
import { MakeSocketConnection, SocketSync, UpdateUserDataInCacheDBSocket, UpdateDangDataInCacheDBSocket, MirraclesSync } from './SocketAPI';
import { AreYouIOS, showConfirmBoxWithCancel,ProcessUserData,SaveExceptionToSentry,SaveCleintWaufli } from "./RUtility";
const OverlayComponenet = lazy(() => import('./OverlayComponent'));
const EpassOverlayComponent = lazy(() => import('./epassOverlayComponent'));
const SignUp = lazy(() => import('./signup'));
const GuestHandlerCompenent = lazy(() => import('./GuestHandler'));

const C404 = lazy(() => import('./404'));

const dataStore = createStore(reducer);



window.historyInstance = createBrowserHistory();
//import { Provider } from "react-redux";
//import { createStore } from "redux";
//import reducer from "./DataStore";
//import reduxExample from "./ReduxExample";
//import ScrollRestoration from 'react-scroll-restoration'
//const vehicle = createStore(reducer);

//var newTimeout = 3000;

// const transitionStyles = {
//     entering: { opacity: 1 },
//     entered: { opacity: 1 },
//     exiting: { opacity: 0 },
//     exited: { opacity: 0 },
// };

const AnimatedSwitch = withRouter(({ location }) => (
    <TransitionGroup>
        <CSSTransition key={location.key} classNames="slide" timeout={{

            enter: 1,
            exit: 250,
        }} >
            <Switch location={location} >

                <Route path={["/bookedassessments", "/pinnacleip", "/cart", "/s/", "/changecoverphoto","/fcrc","/BBP","/autismgpt","/gptcategory","/pendingsgpt", "/opencreations", "/sendmessagetotelegram", "/categories", "/d/r", "/people", "/search", "/compensation", "/notifications", "/hanuman", "/hanuman:id", "/createexpense", "/createparent", "/trumpet", "/publishscreen", "/serviceland", "/createservice", "/createstaff", "/createlead", "/leaverequest", "/guru/:id", "/guru/name/:id", "/services/:id", "/assessment/:id", "/usercard", "/usercard/:id", "/blackbox", "/changemobilenumber", "/profile", "/privacypolicy", "/faq", "/contactus", "/termsofuse", "/refundpolicy", "/career", "/cookiepolicy", "/AdvancedInvoices", "/allinvoices", "/wallet", "/sanjeevani", "/dietplan", "/pranayamas", "/meditation", "/subscription", "/testimonial", "/referral", "/team", "/vision", "/mission", "/media-coverage", "/kotiigroup", "/bhclpl", "/values", "/innovation", "/package", "/profiles", "/lifestyles", "/consultations", "/healthconditions", "/rconsultations", "/assessments", "/parameters", "/deactivation", "/seemore", "/feedback", "/offers", "/favorites", "/bookmarks", "/attendance", "/payment", "/maddress", "/o/:id", "/po/:id", "/aboutus", "/pd/completedorders", "/attendancekpi", "/serviceskpi", "/goalskpi","/wip", "/assessmentskpi", "/bookassessment", "/mirraclesreport", "/mirraclesassigned", "/mirraclesconfig", "/allawards", "/allmemos", "/pendinginvoices", "/hermes", "/goalsetting", "/createinvoice", "/updateinvoice", "/pti", "/touchbase", "/forcelogoff", "/microphoneguide", "/payments", "/nuture", "/kubera", "/kpireport", "/bossreceipts", "/mirraclebypinnacle", "/mirracles", "/pinnacleidcard", "/allcertificates", "/talentacquisition", "/royalty", "/contributions", "/bankdetails", "/pfdetails", "/genericreports", "/allservicerequests", "/recents", "/allparentleaves", "/alltherapistleaves", "/roffers", "/allcompensations", "/payslip", "/salarystatement", "/basicdetails", "/cleaves", "/leaveapprovals", "/availableslots", "/dangkpi", "/mirracletopbanner", "/prosuggestions", "/therapistleaverequest", "/servicerequestdetails/:id", "/goal/:id","/playground","/servicerequest"]} >

                    <OverlayComponenet />

                </Route>




                <Route path={["/guesthandler"]} >

                    <GuestHandlerCompenent />

                </Route>

                <Route path={["/signup"]} >

                    <SignUp />

                </Route>

                <Route path={["/epass", "/validate-otp"]} >
                    <EpassOverlayComponent />
                </Route>


                <Route path={["/", "/home", "/more", "/updates", "/d", "/d/ff", "/d/o"]}>
                </Route>

                <Route path={["*"]}>
                    <C404 />
                </Route>
            </Switch>
        </CSSTransition>

    </TransitionGroup>
));
export const updateUserDataInCacheDB = (result, callback) => {
    UpdateUserDataInCacheDBSocket(result, callback);
}

export const updateDangDataInCacheDB = (result, callback) => {
    UpdateDangDataInCacheDBSocket(result, callback);
}

export const updateMasterDataInLocalStorage = (result) => {

    // UpdateMasterDataInLocalStorage(result);
}

///
export const DispatchFromAppJs = (data,user) => {
    try{
        console.log("Dispatch Called ");

        dataStore.dispatch(StoreUserData(data));

        dataStore.dispatch(StoreUser(JSON.parse(JSON.stringify(user))));

        console.log("AFTER Dispatch");
    }
    catch(e){
        //console.log(e);
        SaveCleintWaufli(e,"DispatchFromAppJs Failed ","app.js");
    }
}

let onlyOnce = false;

let apiCacheName = 'APICACHE';
var currentPersonInLocal;
class App extends React.Component {
    constructor(props) {
        super(props);

        if (onlyOnce) return;

        var appConstructorStartDateTime = new Date();

        console.log("App Constructor Start :" + appConstructorStartDateTime);
        // KOTI :: localStorage.setItem("UsageType", "1");


        // KOTI

        // var currentUrl = window.location.pathname;
        // if (window.historyInstance.length == 0 && window.location.href != "/d" && window.location.href != "/epass" && window.location.href != "/") {
        //     window.historyInstance.push("/d");
        //     window.historyInstance.push(currentUrl);
        // }


        this.user = localStorage.getItem("UserData");

        if (!this.user && !getFromCookie("UserData")) {
            this.user = getFromCookie("UserData");
        }
        else if (!getUserToken()) {
            window.historyInstance.push("/epass");
            return;
        }

        var authToken = getUserToken();

        console.log(authToken);
        if (!authToken) {
            // window.location.href = "https://www.pinnacleblooms.org/epass?navigateTo=" + encodeURIComponent(window.location.href);
            window.historyInstance.push("/epass");
            return;
        }

        this.currentPersonDetails = JSON.parse(localStorage.getItem("UserData"));

        dataStore.dispatch(StoreUser(this.currentPersonDetails));




        if (window.location.href.indexOf("/mirracles") == -1) {

            // window.historyInstance.push("/mirracles");
            // window.historyInstance.push("/mirracles");


            if (this.currentPersonDetails && this.currentPersonDetails.F11 != "YES") {

            }
            else if (this.currentPersonDetails && !this.currentPersonDetails.F15) {
                showConfirmBoxWithCancel("Joyful, Useful, Learning Empowerment from Certified, Qualified, Expert Therapists.", "Pinnacle Mirracles : Kids Wonderful LIFE", "Show Pinnacle Mirracles{#}Go to Dashboard", false, function (data) {
                    if (!data) {
                        window.historyInstance.go(-1);
                    }
                });
            }

        }


        if (authToken && window.location.pathname.indexOf("epass") > -1) {
            window.historyInstance.push("/d");
        }
        if (authToken && !currentPersonInLocal) {
            var number = getFromCookie("validatormobilenumber-s");
            //console.log(number);
            //GetPersonByMobileNumber(function (result) {
            //    currentPersonInLocal = result;
            //    dataStore.dispatch(StoreUser(result));
            //});
        }

        dataStore.dispatch(StoreAuthToken(authToken));

        /* KOTI :: START THIS BLOCK IS NOT BEING OF USE - CONSUME MASTER FROM SINGLE DATA UNIT*/
        // var response = localStorage.getItem("MasterData");
        // if (response) {
        //     var repos = JSON.parse(response);

        //     this.state = { MasterData: repos, UserData: {} };

        //     if (currentPersonInLocal) {
        //         //  this.state = { IsDataLoaded: true, MSD: repos.MasterData, GL: repos.GList, US: repos.USettings, CartCount: 0, currentPersonDetails: currentPersonInLocal, DashboardUserDataList: [], FamilyMembersDataObj: [] };
        //         this.state = { IsDataLoaded: true, MasterData: repos, currentPersonDetails: currentPersonInLocal };
        //     }
        //     else {
        //         this.state = { IsDataLoaded: true, MasterData: repos, UserData: {} };
        //     }


        //     dataStore.dispatch(StoreMasterData(repos));
        // }
        // else
        // {
        //     // ?
        // }
        /* KOTI :: END TILL HERE */

        var currentUser =this.currentPersonDetails;

        var dataExists = false;
        try {

            var date1 = new Date();
            console.log("Cache about to be opened:" + (appConstructorStartDateTime - date1));
            
            caches.open(apiCacheName).then(cache => {
                console.log("#1. Connection Open:" + (new Date() - date1));
                window.globalCacheInstance = cache;
                cache.match("/PSUserData").then(async userDataResponse => {


                    try
                    {
                    console.log("#2. Acquired User Data:" + (new Date() - date1));

                    console.log(userDataResponse);

                  
                   


 //CALCULATE THE STORGE 

                        try {
                            navigator.storage.estimate().then(({ usage, quota }) => {
                                var usagePercentage = ((usage / quota) * 100);
                                console.log("Storage Manager Usage :" + usagePercentage + "%");

                                try {
                                    if (usagePercentage >= 70) {

                                        var exceptionMessage = "Quota: " + quota + " Used: " + usage + " Percentage: " + usagePercentage + "%, Code: " + (currentUser.Code ? currentUser.Code : currentUser.Id) + "\n\nName:" + currentUser.Name + "\n\n" + "Handle:" + currentUser.Handle + ",\n\nBrowser Agent:" + navigator.userAgent;
                                        var exception = {};
                                        exception.Type = "LOWMEMORYDEVICES";
                                        exception.Message = exceptionMessage;
                                        SaveExceptionToSentry(exception, "Error", getUserToken(), "LOWMEMORYDEVICES");

                                    }
                                }
                                catch (e) {
                                    console.log("Error IN Low Memory device log", e)
                                }

                            });
                        }
                        catch (e) {
                            console.log("Storage Estimation Error", e)
                        }

                    console.log("response: ", userDataResponse);
                    if (userDataResponse) {




                        //var results = JSON.parse(userDataResponse.text());
                        //   console.log("#2. Data Parsed :"+ (new Date() - date1));
                        // console.log("resultObj",results);
                        var resultObj = JSON.parse(await userDataResponse.text());
                        dataExists = true;
                       // window.localCacheData = resultObj;
                        //console.log("resultObj");
                        console.log("#3. UserData JSON :" + (new Date() - date1));



                          //CALCULATE THE STORAGE NO NEED TO ANY
  try{
    console.log("VISUALIZE LOCAL DATA")
    console.log("Entity,STDate,EnDate,Count,Size,JulyLength,JulySize");
    var dateCurrent = new Date();
    var firstDay = new Date(dateCurrent.getFullYear(), dateCurrent.getMonth(), 1);
    Object.keys(resultObj).forEach((key, index) => {

        try{
            if (resultObj[key].length > 0) {
                var data = resultObj[key];
                //console.log(key);
                if(key == 'LastSyncDataTime'){
                    return;
                }
                let combinedDates = data.reduce((acc, obj) => { acc.push(obj.CDT); return acc; }, []);
    
                //console.log("GETHIGHEST COMBINED FOR " + type);
                
               // let dateToReturn =  new Date(Math.max.apply(null, combinedDates.map(function (e) {return new Date(e);})));
              
               let sortByDescending = combinedDates.map(function (e) {return new Date(e);}).sort(function (a, b) {return a > b ? -1 : 1 })[0];
               let sortByAscending = combinedDates.map(function (e) {return new Date(e);}).sort(function (a, b) {return a > b ? 1 : -1 })[0];
               var size = (JSON.stringify(data).length/(1024*1024)).toFixed(2);
              
                var julyData = data.filter(t => new Date(t.CDT) >= firstDay);
                if (key == "Fee") {
                    julyData = data.filter(t => new Date(t.CDT) >= firstDay || new Date(t.FDT) >= firstDay);
                }
               var sizeForJuly = (JSON.stringify(julyData).length/(1024*1024)).toFixed(2);     
                
                 console.log(key+","+sortByDescending.toLocaleDateString()+","+sortByAscending.toLocaleDateString()+","+data.length+","+size+","+julyData.length+","+sizeForJuly);
            //     //console.log(TableLastSyncDateTime[key]);
            //    // console.log(result[key]);
            //     if(TableLastSyncDateTime[key]){
            //         SetLocalStorage(TableLastSyncDateTime[key], GetHighestCDTorUDT(result[key],key));
            //     }
            }
        }
        catch(e){
            console.log("Size Error for " + key);
            return;
        }
        

    });
}
catch(e){
    console.log("ERROR IN LOCAL DATA SIZE CALCULATION",e);
}
                        

                        ProcessUserData(resultObj,dataStore,null);
                      //  dataStore.dispatch(StoreUserData(resultObj));
                        console.log("#4. User data in Rect Store:" + (new Date() - date1));

                        if (resultObj && resultObj.UserSettings && AreYouIOS()) {
                            var d = $.grep(resultObj.UserSettings, function (e) {

                                return e.Name == "IOSSETTINGSNATIVEENABLE"
                            })[0];

                            if (d) {
                                window.location.href = "mirraclescheme://permissions?" + d.Value.replace("&amp;", "&");
                            }
                        }

                                  //  KOTI :: START SYNC CALL.
                //     MakeSocketConnection(authToken, dataStore, function (res) {
                //         console.log("WebSocket Connection Established Successfully.");
                //         console.log(new Date());
                //         SocketSync(0, function (data) {
                //             // console.log(data);
                //             console.log("After Sync");
                //             console.log(new Date());
                //         });
                // // KOTI :: END SYNC CALL.
                //     });

                    }
                   // else {
                        //  KOTI :: START SYNC CALL.
                        MakeSocketConnection(authToken, dataStore, function (res) {
                            console.log("WebSocket Connection Established Successfully.");
                            console.log(new Date());
                            SocketSync(0, function (data) {
                                // console.log(data);
                                console.log("After Sync");
                                console.log(new Date());
                            });
                            // KOTI :: END SYNC CALL.
                        });

                  //  }
                    }
                    catch(e)
                    {
                        SaveExceptionToSentry(e, "Error", getUserToken(), "APP-CACHE-STORE");
                    }
                });
            });


        } catch (e) {
            SaveCleintWaufli(e,"Cache failed"," app.js");
            SaveExceptionToSentry(e, "Error", getUserToken(), "APPJS - CONSTRUCTOR");
            console.error("App Constructor Error" + e);
        }

        console.log("App Constructor End:" + (new Date() - appConstructorStartDateTime));
        onlyOnce = true;

    }



    handleVisibilityChange = isVisible => {
        if (isVisible) {
            console.log("ENTERED INTO FOCUS");
            try {
                // console.log("Is Screen Visible : " + isVisible);
                var authToken = getUserToken();
                if (isVisible && authToken) {
                    // SocketSync(0, function (data, error) {
                    //     // console.log(data);
                    // }, true);


                    // Load Mirracles in Initial Load
                    // MirraclesInitialLoad(function(data,error){
                    //    if (!error) {

                    //  var resData = {
                    //      MirraclesMore: res.Data,
                    //  };

                    //   updateUserDataInCacheDB(resData, function (result) {

                    //      //setTimeout(function () {
                    //          dataStore.dispatch(StoreUserData(result));
                    //   });
                    //  }
                    // else
                    //{
                    //}
                    //});


                }
            } catch (err) {
                console.log("Error in handleVisibilityChange :: " + err);
            }
        }
    }
    //VerifyRoyaltyPayment = function () {
    //    if (this.props.userData && this.props.userData.FData) {
    //        var data = $.grep(this.props.userData.FData, function (e) { return e.AT == "ROYALTY" })[0];
    //        var $this = this;
    //        if (data) {
    //            showConfirmBoxWithCancel("", "Please do clear royalty amount", "Cleared Already", false, function (data) {

    //                    window.historyInstance.go(-1);

    //            });
    //        }
    //    }
    //}
    //componentDidUpdate(prevProps, prevState, snapshot) {

    //    //console.log(url);

    //    if (this.props && this.props != prevProps && this.props.userData && this.props.userData.FData) {
    //        //console.log("ENTERED");

    //        this.VerifyRoyaltyPayment();

    //    }
    //    //console.log("====DIDComponenet==");
    //}

    //<ScrollRestoration />

    render() {
        return <Provider store={dataStore}>
            <Router history={window.historyInstance}>
                <ErrorBoundary>
                    <PageVisibility onChange={this.handleVisibilityChange} >
                        <Home />
                    </PageVisibility>


                    <Suspense fallback={<LoadingPlaceHolder IsPageLoaderReqired={true} Height="1000px" />}>

                        <AnimatedSwitch />

                    </Suspense>
                </ErrorBoundary>
            </Router>
        </Provider>

    }
}
const mapStateToProps = state => {
    return {
        // To get the list of employee details from store
        userData: state.UD,
        MasterData: state.MD
    }
};

export default connect(mapStateToProps, null)(App)

export function getStore() {
    return dataStore;
}

$(document).ready(function () {


    $(document).on("click", function (e) {
        // alert(e);

    });
    $("body").on('click', '.footerNav', function (e) {

        var type = $(this).attr('data-type');
        window.historyInstance.push("/search/" + type);
        e.preventDefault();
        e.stopPropagation();
    });

    $("body").on('click', '.footerNav22', function (e) {

        e.preventDefault();
        e.stopPropagation();
    });

    $("body").on('click', '.footerNavInnerPage22', function (e) {
        //var type = $(this).attr('data-type');
        //window.historyInstance.push("/search/" + type);
        e.preventDefault();
        e.stopPropagation();
    });


    $("body").on('click', '.footerNavInnerPage', function (e) {

        var type = $(this).attr('data-type');
        window.historyInstance.push("/m/" + type);
        e.preventDefault();
        e.stopPropagation();
    });

    $("body").on('click', '.showfaq', function (e) {

        window.historyInstance.push("/faq");
        e.preventDefault();
        e.stopPropagation();

    });

    $("body").on('click', '.privacy-policy', function (e) {

        window.historyInstance.push("/privacypolicy");
        e.preventDefault();
        e.stopPropagation();

    });


    var appType = localStorage.getItem("validatorapptype-s");
    // var url = location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const clientType = urlParams.get('ct');
    if (clientType && !appType) {
        localStorage.setItem("validatorapptype-s", clientType);
    }

    console.log(clientType);
});




export function UpdateUserData(result) {
    dataStore.dispatch(StoreUserData(result));
}
function getFromCookie(type) {
    try {
        var result = cookie.load(type);
        return result;
    } catch (e) {
        console.log(e);
    }
}

function getUserToken() {
    var token = ""
    try {
        token = cookie.load('validatorauth-s');

        if (!token) {
            token = localStorage.getItem("validatorauth-s");
        }
        // console.log(token);
    } catch (e) {

        console.log("error in reading token from cookie...");
        console.log(e);
        token = localStorage.getItem("validatorauth-s");
    }

    return token;
}

